import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { forgotPasswordInterface } from "../interfaces/forgotPassword.interface";

export async function forgotPasswordAction(
  email: string
): Promise<ApiResponse<forgotPasswordInterface>> {

  const { data } = await apiClient.post<forgotPasswordInterface>(
    "/auth/forgotPassword",
    { email } 
  );

  return {
    status: 200,
    data,
    message: "Se envió el correo de recuperación correctamente",
  };
}
